var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGem(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 104,
    height: 74,
    viewBox: "0 0 104 74",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M79.0455 1H26.1136L1 22.6774L51.2273 73L103 22.6774L79.0455 1Z",
    stroke: "#868686"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGem);
export default __webpack_public_path__ + "static/media/gem.f32a69bdd2e74b39c7873dec76b13543.svg";
export { ForwardRef as ReactComponent };